module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "custom-select multi",
    class: {
      solo: _vm.solo
    }
  }, [_c('div', {
    staticClass: "selected",
    on: {
      "click": function($event) {
        return _vm.display()
      }
    }
  }, [(_vm.selected.length > 0) ? _c('div', {
    staticClass: "ctn-tags row"
  }, _vm._l((_vm.selected), function(tag, key) {
    return _c('div', {
      key: key,
      staticClass: "tag",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.remove(key)
        }
      }
    }, [_vm._v("\n\t\t\t\t" + _vm._s(_vm.displayItem(tag)) + " "), _vm._m(0, true)])
  }), 0) : _c('div', {
    staticClass: "no-tags"
  }, [_vm._v("\n\t\t\t \n\t\t")]), _vm._v(" "), _c('span', {
    staticClass: "icon-arrow-full-down",
    class: {
      deploy: _vm.show
    }
  })]), _vm._v(" "), (_vm.show) ? _c('div', {
    staticClass: "items"
  }, _vm._l((_vm.list), function(item, key) {
    return _c('div', {
      key: key,
      staticClass: "item",
      class: {
        active: _vm.isSelected(key)
      },
      on: {
        "click": function($event) {
          return _vm.setSelect(key)
        }
      }
    }, [_vm._v("\n\t\t\t" + _vm._s(_vm.displayItem(item)) + "\n\t\t")])
  }), 0) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "delete row"
  }, [_c('span', [_vm._v("x")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-846e832a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/common/components/Form/CustomMultiselect.vue
// module id = 1156
// module chunks = 0